// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"8d780e43","629":"c95d419e"}[chunkId] + ".chunk.js";
};